import { render } from "./UangMasukAddModal.vue?vue&type=template&id=d58b75d2&scoped=true"
import script from "./UangMasukAddModal.vue?vue&type=script&lang=js"
export * from "./UangMasukAddModal.vue?vue&type=script&lang=js"

import "./UangMasukAddModal.vue?vue&type=style&index=0&id=d58b75d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d58b75d2"

export default script